<template>
  <v-btn
    :disabled="disabled"
    @click="$emit('volver')"
    class="titleColor--text ml-0 pl-0 mb-0"
    flat
  >
    <v-icon class="mr-1">chevron_left</v-icon>
    <span>{{texto}}</span>
  </v-btn>
</template>

<script>
export default {
  name: 'o-btn-volver',
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    texto: {
      type: String,
      default () {
        return this.$t('general.misc.volver')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/generic/OBtnVolver.vue